import { ReactNode } from 'react'
import classNames from 'classnames/bind'

import LogoWom from '../../images/svg/logo-wom.svg'

import * as styles from './index.module.scss'

const cx = classNames.bind(styles)

type MainProps = {
  children: ReactNode
}

const FrameLayout = ({ children }: MainProps) => {
  return (
    <div className={cx('frame-layout', styles.frameLayout)}>
      <header className={cx(styles.topBar)}>
        <LogoWom className={cx(styles.topBar__logo)} />
      </header>
      <div className={cx(styles.gradient)} />
      <div className={cx(styles.canvas)}>
        <header className={cx(styles.canvas__header)}>
          <p>
            Todas tus recargas duran <strong>180 días</strong> e incluyen{' '}
            <strong>WhatsApp Ilimitado</strong> hasta por 30 días y hasta{' '}
            <strong>4 Gigas</strong> gratis.
          </p>
          <p>No necesitas saldo para recargar.</p>
        </header>
        {children}
      </div>
      <div className={cx(styles.gradient)} />
      <footer className={cx(styles.bottomBar)}>
        <div className={cx(styles.bottomBar__content)}>
          <LogoWom className={cx(styles.bottomBar__logo)} />
          <span>Todos los derechos reservados a WOM SpA 2025</span>
        </div>
      </footer>
    </div>
  )
}

export default FrameLayout
